export interface OrderDetailNavState {
  fromPath: string;
  siblingOrderIds: readonly (string | number)[];
}

export const DEFAULT_ORDER_DETAIL_FROM_PATH = '/order-manager';

const PICK_NEXT_NAV_STATE: OrderDetailNavState = {
  fromPath: DEFAULT_ORDER_DETAIL_FROM_PATH,
  siblingOrderIds: [],
};

export function buildOrderDetailNavState(
  fromPath: string,
  orders: readonly { orderId: string | number }[],
): OrderDetailNavState {
  return {
    fromPath,
    siblingOrderIds: orders.map((order) => order.orderId),
  };
}

export function buildPickNextOrderNavState(): OrderDetailNavState {
  return PICK_NEXT_NAV_STATE;
}

export function parseOrderDetailNavState(state: unknown): OrderDetailNavState {
  if (!state || typeof state !== 'object') {
    return { fromPath: DEFAULT_ORDER_DETAIL_FROM_PATH, siblingOrderIds: [] };
  }
  const fromPathValue = 'fromPath' in state ? state.fromPath : undefined;
  const siblingValue = 'siblingOrderIds' in state ? state.siblingOrderIds : undefined;
  const fromPath =
    typeof fromPathValue === 'string' && fromPathValue.startsWith('/')
      ? fromPathValue
      : DEFAULT_ORDER_DETAIL_FROM_PATH;
  const siblingOrderIds = Array.isArray(siblingValue)
    ? siblingValue.filter(
        (id: unknown): id is string | number =>
          typeof id === 'string' || typeof id === 'number',
      )
    : [];
  return { fromPath, siblingOrderIds };
}

export function findSiblingIndex(
  siblingOrderIds: readonly (string | number)[],
  orderId: string | undefined,
): number {
  if (orderId == null) return -1;
  return siblingOrderIds.findIndex((id) => String(id) === String(orderId));
}
